import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import ReportCard from 'shared/component/reportCard';
import { DashboardPageContext } from 'page/dashboard/index';

export default function CenterReportCardsGrid() {
  const { dashboardData } = useContext(DashboardPageContext);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={3}>
        <ReportCard
          title="Escalados"
          quantity={dashboardData?.data_scales?.scaled || 0}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <ReportCard
          title="Ocorrendo"
          quantity={dashboardData?.data_scales?.happening || 0}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <ReportCard
          title="Realizados"
          quantity={dashboardData?.data_scales?.finished || 0}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <ReportCard
          title="Faltas"
          quantity={dashboardData?.data_scales?.missed || 0}
        />
      </Grid>
    </Grid>
  );
}
